import CustomInstructionsResponsePlugin from "../../customPlugin/customInstructions";
import { instructionPage } from "../../lib/utils";
import { tutorialGlobalToggles } from "../../config/tutorialToggles";

const INSTRUCTIONS_AMBIENCE = "assets/audio/CG01_12_Ambience_V1_2min_loop.mp3";

/** The key the moves to the next instruction screen */
export const KEY_FORWARD = "Slash";

/** The key the moves to the previous instruction screen */
export const KEY_BACKWARD = "KeyZ";

/**
 * Builds a trial that displays a given set of instructions
 * @param {JsPsych} jsPsych jsPsych instance being used to run the task
 * @param {Array} pages The pages of instructions (as strings) to be displayed
 * @returns
 */
export function buildInstructionsTrial(jsPsych, pages, opts = {}) {
  const {
    ambient_audio_src,
    ambient_audio_loop,
    show_overlay_nav_text,
    overlay_nav_text,
    ...pluginOpts
  } = opts;

  const resolvedAmbientAudioSrc =
    typeof ambient_audio_src !== "undefined"
      ? ambient_audio_src
      : tutorialGlobalToggles.instructionsAmbientAudio
        ? INSTRUCTIONS_AMBIENCE
        : undefined;

  return {
    type: CustomInstructionsResponsePlugin,
    data: { name: "instructions" },
    show_page_number: true,
    pages,
    enable_instructions_review_tip: true,
    ambient_audio_src: resolvedAmbientAudioSrc ?? null,
    ambient_audio_loop: ambient_audio_loop ?? true,
    show_overlay_nav_text: show_overlay_nav_text ?? true,
    overlay_nav_text: overlay_nav_text ?? null,
    key_forward: KEY_FORWARD,
    key_backward: KEY_BACKWARD,
    ...pluginOpts,
  };
}

/**
 * Builds the trial for displaying the quiz specific game instructions
 * @param {JsPsych} jsPsych jsPsych instance being used to run the task
 * @param {Score} score The Score instance used to keep track of the user's score within the mission
 * @param {Array} images An array of images shown as the instructions
 * @param {Object} [overlayOptions] Optional overlay configuration (overlayLeftPercent, overlayTopPercent, overlayNavText, showBackKey, showForwardKey)
 */
export function buildQuizInstructions(jsPsych, score, images, overlayOptions = {}) {
  const {
    overlayLeftPercent = 58,
    overlayTopPercent = 89.5,
    overlayNavText = '[ press "__FORWARD_KEY__" to continue ] ',
    showBackKey = false,
    showForwardKey = true,
    overlayTextSizeVw,
    showOverlayNavText = true,
  } = overlayOptions;

  return {
    type: CustomInstructionsResponsePlugin,
    data: { name: "instructions" },
    pages: images.map((image) => instructionPage(image, undefined, {
      overlayLeftPercent,
      overlayTopPercent,
      showBackKey,
      showForwardKey,
      overlayTextSizeVw,
    })),
    ambient_audio_src: null,
    on_finish: (data) => score.assignScore(data),
    key_forward: "Slash",
    key_backward: "KeyZ",
    show_overlay_nav_text: showOverlayNavText,
    overlay_nav_text: overlayNavText,
  };
}
